import React from "react";

interface SidebarProps {
  activeNav: string;
  onNavChange: (nav: string) => void;
  isOpen?: boolean;
  onClose?: () => void;
}

interface NavItem {
  id: string;
  label: string;
  icon: string;
}

const Sidebar: React.FC<SidebarProps> = ({ activeNav, onNavChange, isOpen, onClose }) => {
  const menuItems: NavItem[] = [
    { id: "dashboard", label: "Dashboard", icon: "fa-solid fa-table-columns" },
    { id: "queries", label: "Queries", icon: "fa-solid fa-comments" },
    { id: "Lead", label: "Lead", icon: "fa-solid fa-database" },
    { id: "help", label: "Help", icon: "fa-regular fa-circle-question" },
    { id: "health", label: "System Health", icon: "fa-solid fa-heart-pulse" },
    { id: "settings", label: "Settings", icon: "fa-solid fa-gear" },
  ];

  const handleNavClick = (id: string) => {
    onNavChange(id);
    if (onClose) {
      onClose();
    }
  };

  return (
    <aside className={`admin-sidebar ${isOpen ? "open" : ""}`}>
      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <div
            key={item.id}
            onClick={() => handleNavClick(item.id)}
            className={`sidebar-item ${activeNav === item.id ? "active" : ""}`}
          >
            <i className={`${item.icon} sidebar-icon`} />
            <span>{item.label}</span>
          </div>
        ))}
      </nav>

      <div className="sidebar-logout" onClick={() => handleNavClick("logout")}>
        <i className="fa-solid fa-right-from-bracket sidebar-icon" />
        <span>Logout</span>
      </div>
    </aside>
  );
};

export default Sidebar;
